<template>
  <div id="preferences">
    <mu-card-header titleClass="boldTitle largeTitle" :title="title" :subTitle="subTitle"></mu-card-header>
    <form>
      <div class="wrapPreferences">
        <mu-row>
          <mu-col desktop="60" tablet="100" width="100" class="radioText">
            <label>{{$t('message.marketingPreferencePromotion')}}</label>
            <p v-text="$t('message.marketingPreferencePromotionExplain')"></p>
          </mu-col>
          <mu-col desktop="20" tablet="50" width="50" class="centerItems radioButtons">
            <mu-radio name="promotions" :nativeValue="false" :label="$t('message.labelNo')" v-model="model.email_promotions"/>
          </mu-col>
          <mu-col desktop="20" tablet="50" width="50" class="centerItems radioButtons">
            <mu-radio name="promotions" :nativeValue="true" :label="$t('message.labelYes')" v-model="model.email_promotions"/>
          </mu-col>
        </mu-row>
        <mu-row>
          <mu-col desktop="60" tablet="100" width="100" class="radioText">
            <label>{{$t('message.marketingPreferenceSurveys')}}</label>
            <p v-text="$t('message.marketingPreferenceSurveysExplain')"></p>
          </mu-col>
          <mu-col desktop="20" tablet="50" width="50" class="centerItems radioButtons">
            <mu-radio name="research" :nativeValue="false" :label="$t('message.labelNo')" v-model="model.email_research"/>
          </mu-col>
          <mu-col desktop="20" tablet="50" width="50" class="centerItems radioButtons">
            <mu-radio name="research" :nativeValue="true" :label="$t('message.labelYes')" v-model="model.email_research"/>
          </mu-col>
        </mu-row>
        <mu-row>
          <mu-col desktop="60" tablet="100" width="100" class="radioText">
            <label>{{$t('message.marketingPreferenceNewsletters')}}</label>
            <p v-text="$t('message.marketingPreferenceNewslettersExplain')"></p>
          </mu-col>
          <mu-col desktop="20" tablet="50" width="50" class="centerItems radioButtons">
            <mu-radio name="newsletter" :nativeValue="false" :label="$t('message.labelNo')" v-model="model.email_newsletter"/>
          </mu-col>
          <mu-col desktop="20" tablet="50" width="50" class="centerItems radioButtons">
            <mu-radio name="newsletter" :nativeValue="true" :label="$t('message.labelYes')" v-model="model.email_newsletter"/>
          </mu-col>
        </mu-row>
        <mu-row>
          <mu-col desktop="60" tablet="100" width="100" class="radioText">
            <label>{{$t('message.marketingPreferenceUpdates')}}</label>
            <p v-text="$t('message.marketingPreferenceUpdatesExplain')"></p>
          </mu-col>
          <mu-col desktop="20" tablet="50" width="50" class="centerItems radioButtons">
            <mu-radio name="updates" :nativeValue="false" :label="$t('message.labelNo')" @change="open" v-model="model.email_updates"/>
          </mu-col>
          <mu-col desktop="20" tablet="50" width="50" class="centerItems radioButtons">
            <mu-radio name="updates" :nativeValue="true" :label="$t('message.labelYes')" v-model="model.email_updates"/>
          </mu-col>
        </mu-row>
        <mu-row>
          <mu-col desktop="60" tablet="100" width="100" class="radioText">
            <label>{{$t('message.communityEmailPreferences')}}</label>
            <p v-text="$t('message.communityEmailPreferencesExplain')"></p>
          </mu-col>
          <mu-col desktop="20" tablet="50" width="50" class="centerItems radioButtons">
            <mu-radio name="community" :nativeValue="false" :label="$t('message.labelNo')" @change="open" v-model="model.email_community"/>
          </mu-col>
          <mu-col desktop="20" tablet="50" width="50" class="centerItems radioButtons">
            <mu-radio name="community" :nativeValue="true" :label="$t('message.labelYes')" v-model="model.email_community"/>
          </mu-col>
        </mu-row>
      </div>
      <div class="btnwrap">
        <mu-raised-button secondary :label="$t('message.updateText')" class="large" @click.native="savePreferences" fullWidth/>
      </div>
      <mu-dialog v-if="$store.state.status.payment.paid" :open="dialog" title="Just a moment..." @close="close">
        Opting out will mean that you will no longer received Personalised Support emails which are included as part of the fee for the Low Carb Program. Are you sure you wish to opt out of this paid for feature?
        <mu-flat-button slot="actions" @click="close" primary label="Opt out"/>
        <mu-flat-button slot="actions" primary @click="closeSet" label="Cancel"/>
      </mu-dialog>
    </form>
  </div>
</template>
<script>
  import AccountApi from '../../api/Account';
  ;

  export default {
    name: 'settings-preferences',
    watch: {
      "route": function () {
        let self = this;
        self.getPreferences();
      }
    },
    data() {
      return {
        title: this.$t('message.marketingPreferencesTitle'),
        subTitle: this.$t('message.marketingPreferencesSubTitle'),
        dialog: false,
        model: {
          email_promotions: null,
          email_research: null,
          email_newsletter: null,
          email_updates: null,
          email_community: null,
        },
      }
    },
    methods: {
      getPreferences() {
        let self = this;
        AccountApi.getMarketingPreferences().then(response => {
          let data = response.data;
          if(data.has_engaged_preference) {
            self.model.email_promotions = data.email_promotions;
            self.model.email_research = data.email_research;
            self.model.email_newsletter = data.email_newsletter;
            self.model.email_updates = data.email_updates;
            self.model.email_community = data.email_community;
          } else {
            self.model.email_updates = true;
            self.$forceUpdate();
          }
        });
      },
      savePreferences() {
        let self = this;
        if ((self.model.email_promotions === null) || (self.model.email_newsletter === null) || (self.model.email_research === null) || (self.model.email_updates === null) || (self.model.email_community === null)) {
          self.$toastr.error('Please select all your communication preferences');
        } else {
          AccountApi.updateMarketingPreferences(self.model)
            .then(function (response) {
              self.$toastr.success('Updated');
              self.$store.state.user.scope.has_engaged_preference = true;
            })
        }

      },
      open() {
        let self = this;
        self.dialog = true;
      },
      close() {
        let self = this;
        self.dialog = false;
      },
      closeSet() {
        let self = this;
        self.dialog = false;
        self.model.email_updates = true;
      }
    },
    mounted() {
      let self = this;
      self.getPreferences();
    },
  }
</script>

<style lang="less">
  #preferences {
    .wrapPreferences {
      .row {
        padding: 20px;
        &:nth-child(even) {
          background: #93d4ff36;
        }
        &.tableHeaders {
          margin-bottom: 15px;
          padding: 10px 20px;
          label {
            font-size: 16px;
            color: #0179d5;
            font-weight: bold;
            line-height: 1.5;
          }
        }
        .radioText {
          text-align: left;
          label {
            font-size: 16px;
            line-height: 1.5;
            color: rgba(0, 0, 0, 0.87);
          }
          p {
            font-size: 14px;
            line-height: 1.71;
            color: rgba(57, 57, 57, 0.87);
          }
        }
      }
      .mu-radio-ripple-wrapper {
        width: 48px;
        height: 48px;
        top: -12px;
        left: -12px;
      }
      .centerItems {
        text-align: center;
        &.radioButtons {
          margin-top: 35px;
          svg {
            &.mu-radio-icon-uncheck.mu-radio-svg-icon {
              fill: #8b8686;
            }
          }
        }
      }
    }
    .btnwrap {
      padding: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// Preferences.vue?7ea8b67c